export const gradeTranslation = {
    K: "K",
    FIRST: "1st",
    SECOND: "2nd",
    THIRD: "3rd",
    FOURTH: "4th",
    FIFTH: "5th",
    SIXTH: "6th",
    SEVENTH: "7th",
    EIGHTH: "8th"
};

export const toStableGrade = (g) => reverseGradeTranslation[g] || g;
export const reverseGradeTranslation = Object.fromEntries(
    Object.entries(gradeTranslation).map(([key, value]) => [value, key])
);

export const instructionalAreaToGrade = {
    51: "K",
    52: "FIRST",
    53: "SECOND",
    54: "THIRD",
    55: "FOURTH",
    56: "FIFTH",
    57: "SIXTH"
};

export const indexToGrade = {
    0: "K",
    1: "1st",
    2: "2nd",
    3: "3rd",
    4: "4th",
    5: "5th",
    6: "6th"
};

export const subjectIdToContentAreaId = {
    3: "46", // Math
    6: "47", // Music
    8: "48", // PE
    5: "50", // Science
    4: "51", // Social Studies
    1: "52", //Art
    2: "62" // ELA
};

const GRADE_ORDER = {
    K: 0,
    "1st": 1,
    "2nd": 2,
    "3rd": 3,
    "4th": 4,
    "5th": 5,
    "6th": 6,
    "7th": 7,
    "8th": 8
};

export const sortGrades = (grades = []) =>
    [...grades].sort((a, b) => {
        const aOrder = GRADE_ORDER[a] ?? Number.MAX_SAFE_INTEGER;
        const bOrder = GRADE_ORDER[b] ?? Number.MAX_SAFE_INTEGER;
        return aOrder - bOrder;
    });
